module.exports = __webpack_public_path__ + "img/banner4.85bc0734.png";